import { z } from 'zod';

export const LessonLearnedSchema = z.object({
    id: z.string().optional(),
    category: z.string().min(1),
    details: z.string().min(1),
    actionId: z.string().optional().nullable(),
    exerciseId: z.string().optional().nullable(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateLessonLearnedSchema = LessonLearnedSchema.omit({ id: true });
export const UpdateLessonLearnedSchema = LessonLearnedSchema.partial();
export const LessonsLearnedFormSchema = LessonLearnedSchema;
